const stripTrailingSlash = (str) => {
    if (str.substring(str.length - 1) === '/') {
        return str.substring(0, str.length - 1);
    }
    return str;
};
export const splitSocketUrl = (str) => {
    const socketUrl = stripTrailingSlash(str);
    const urlParts = socketUrl.trim().split('/').filter(Boolean);
    return {
        baseUrl: urlParts[0],
        urlPath: urlParts.length > 1 ? `/${urlParts.slice(1).join('/')}/socket.io/` : undefined
    };
};
